import {
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { RateCard } from '@gigdriver/domain';
import { fromFirestore } from './serde';

function rateCardsCollection(orgId: string) {
  return collection(getFirestoreInstance(), 'organizations', orgId, 'rateCards');
}

export async function createRateCard(
  orgId: string,
  card: Omit<RateCard, 'id' | 'orgId' | 'createdAt' | 'updatedAt'>,
): Promise<string> {
  const ref = doc(rateCardsCollection(orgId));
  await setDoc(ref, {
    ...card,
    id: ref.id,
    orgId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function getRateCard(orgId: string, cardId: string): Promise<RateCard | null> {
  const ref = doc(getFirestoreInstance(), 'organizations', orgId, 'rateCards', cardId);
  const snap = await getDoc(ref);
  return snap.exists() ? fromFirestore<RateCard>(snap.data()) : null;
}

export async function getOrgRateCards(orgId: string): Promise<RateCard[]> {
  const snap = await getDocs(rateCardsCollection(orgId));
  return snap.docs.map(d => fromFirestore<RateCard>(d.data()));
}

export async function updateRateCard(
  orgId: string,
  cardId: string,
  updates: Partial<RateCard>,
): Promise<void> {
  const ref = doc(getFirestoreInstance(), 'organizations', orgId, 'rateCards', cardId);
  await updateDoc(ref, { ...updates, updatedAt: serverTimestamp() });
}

export async function deleteRateCard(orgId: string, cardId: string): Promise<void> {
  await deleteDoc(doc(getFirestoreInstance(), 'organizations', orgId, 'rateCards', cardId));
}
